module.exports = __webpack_public_path__ + "static/media/ios-paw.6ad20a2c.svg";